document.addEventListener("DOMContentLoaded", () => {
  const IO = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const el = entry.target;

      if (entry.isIntersecting) {
        // 요소가 화면 안으로 들어올 때
        if (el.classList.contains("fade-up")) {
          el.classList.add("show");
        }
        if (el.classList.contains("rise-up")) {
          el.classList.add("show");
        }
        if (el.classList.contains("row")) {
          el.querySelectorAll(".slide-in").forEach(img => img.classList.add("show"));
        }
      } else {
        // 요소가 화면 밖으로 나갈 때 → 다시 애니메이션 가능하게 show 제거
        if (el.classList.contains("fade-up")) {
          el.classList.remove("show");
        }
        if (el.classList.contains("rise-up")) {
          el.classList.remove("show");
        }
        if (el.classList.contains("row")) {
          el.querySelectorAll(".slide-in").forEach(img => img.classList.remove("show"));
        }
      }
    });
  }, { threshold: 0.2 });

  document.querySelectorAll(".fade-up").forEach(el => IO.observe(el));
  document.querySelectorAll(".rise-up").forEach(el => IO.observe(el));
  document.querySelectorAll(".row").forEach(row => IO.observe(row));
});


// // 사이드 슬라이드
// document.addEventListener("DOMContentLoaded", () => {
//   const rows = document.querySelectorAll(".row");

//   const io = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         const imgs = entry.target.querySelectorAll(".slide-in");
//         imgs.forEach(img => img.classList.add("show")); 
//       }
//     });
//   }, { threshold: 0.2 });

//   rows.forEach(row => io.observe(row));
// });
// // 서브 페이지 떠오르는 인터렉션
//     const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//         if (entry.isIntersecting) {
//         entry.target.classList.add("show");
//         }
//     });
//     });

//     document.querySelectorAll(".fade-up").forEach(el => observer.observe(el));

// // 컬러팔레트 인터렉션
//     document.addEventListener("DOMContentLoaded", () => {
//   const row = document.querySelector(".color-row");

//   const io = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {

//         const items = entry.target.querySelectorAll(".palette-item");

//         items.forEach((item, index) => {
//           item.style.transitionDelay = `${index * 0.15}s`; 
//           item.classList.add("show");
//         });

//       }
//     });
//   }, { threshold: 0.2 });

//   io.observe(row);
// });

// // 아이콘 인터렉션
// document.addEventListener("DOMContentLoaded", () => {
//   const items = document.querySelectorAll(".icon-anim");

//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {

//         const index = entry.target.dataset.index;
//         entry.target.style.transitionDelay = `${index * 0.12}s`; // 순차 딜레이
//         entry.target.classList.add("show");

//       }
//     });
//   }, { threshold: 0.2 });

//   items.forEach(item => observer.observe(item));
// });